import CountrySelector from '@assets/components/countrySelector';
import keyboardAccessibility from '@assets/components/keyboardAccessibility';
import { hideOnBackgroundClick } from '@project/components/utility';

export default class extends CountrySelector {
    constructor() {
        super();
        this.countrySelectorToggler = $('.dropdown:not(.disabled) [data-toggle="dropdown"]#dropdownCountrySelector');
        this.countrySelectorDropdown = $('.dropdown-country-selector');
    }

    init() {
        window.addEventListener('resize', this.hideCountrySelector.bind(this));
        this.countrySelectorLinkClick();
        this.countrySelectorToggler.on('click', this.handleCountrySelector.bind(this));
        hideOnBackgroundClick('country', this.hideCountrySelector.bind(this));
    }

    handleCountrySelector() {
        if ($('.modal-background').hasClass('country')) {
            this.hideCountrySelector();
        } else {
            this.showCountrySelector();
        }
    }

    hideCountrySelector() {
        this.countrySelectorDropdown.removeClass('show');
        this.countrySelectorDropdown.children('.dropdown-menu').removeClass('show');
        this.countrySelectorToggler.attr('aria-expanded', 'false');
        $('.modal-background').removeClass('country').hide();
    }

    showCountrySelector() {
        this.countrySelectorDropdown.addClass('show');
        this.countrySelectorDropdown.children('.dropdown-menu').addClass('show');
        this.countrySelectorToggler.attr('aria-expanded', 'true');
        $('.modal-background').addClass('country').show();
        this.keyboardEvents();
    }

    countrySelectorLinkClick() {
        $('.country-selector:not(.country-selector-page) a').click(function (e) {
            e.preventDefault();
            const action = $('.page').data('action');
            const localeCode = $(this).data('locale');
            const localeCurrencyCode = $(this).data('currencycode');
            const queryString = $('.page').data('querystring');
            const url = $('.country-selector').data('url');

            $.ajax({
                url,
                type: 'get',
                dataType: 'json',
                data: {
                    code: localeCode,
                    queryString,
                    CurrencyCode: localeCurrencyCode,
                    action,
                },
                success(response) {
                    $.spinner().stop();
                    if (response && response.redirectUrl) {
                        window.location.href = response.redirectUrl;
                    }
                },
                error() {
                    $.spinner().stop();
                },
            });
        });
    }

    keyboardEvents() {
        keyboardAccessibility(
            '.navbar-header .country-selector',
            {
                40($countryOptions) { // down
                    if ($(this).is(':focus')) {
                        $countryOptions.first().focus();
                    } else {
                        $(':focus').next().focus();
                    }
                },
                38($countryOptions) { // up
                    if ($countryOptions.first().is(':focus') || $(this).is(':focus')) {
                        $(this).focus();
                        $(this).removeClass('show');
                    } else {
                        $(':focus').prev().focus();
                    }
                },
                27() { // escape
                    $(this).focus();
                    $(this).removeClass('show').children('.dropdown-menu').removeClass('show');
                },
                9() { // tab
                    $(this).removeClass('show').children('.dropdown-menu').removeClass('show');
                },
            },
            function () {
                if (!($(this).hasClass('show'))) {
                    $(this).addClass('show');
                }
                return $(this).find('.dropdown-country-selector').children('a');
            },
        );
    }
}
